export default __webpack_public_path__ + "static/media/Home.276eec4b.svg";